<template>
  <div class="login-page container">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <div class="columns is-centered">
      <div class="column is-half">
        <h1 class="title">Login</h1>

        <p class="has-text-danger" v-if="$route.query.redirect">
          You need to login first.
        </p>

        <form class="login-form" @submit.prevent="login">
          <b-field label="Email">
                <b-input type="email" placeholder="email" v-model="username"></b-input>
          </b-field> 
          <b-field label="Password">
                <b-input type="password" placeholder="Password" v-model="password"></b-input>
          </b-field> 
          <div class="field is-grouped">
            <div class="control">
              <button class="button is-primary is-medium">Login</button>
            </div>
            <!--<div class="control">-->
            <!--  <router-link class="button is-text is-medium" :to="{name: 'ForgotPage'}">Reset Password</router-link>-->
            <!--</div>-->
          </div>
        </form>
      </div>
    </div>
    
    
  </div>
</template>

<script>
import auth from '../auth.js'
import store from '../store/store.js'
import axios from 'axios';

export default {
  name: 'LoginPage',
  props: ['usernameProp'],
  data () {
    return {
      username: null,
      password: null,
      errorMsg: null,
      isLoading: false,
      isFullPage: true
    }
  },

  created() {
    if( this.usernameProp ){
      this.username = this.usernameProp;
    }
  },
    
    methods: {
      login () {
        this.isLoading = true;
        var self = this;
        auth.login(this.username, this.password, response => {
          if (response.authenticated != true) {
            this.isLoading = false;
            self.errorMsg = response.errorMsg;
            self.error = true;
            store.commit('setUserData', {});
            this.$toast.open({
                    duration: 5000,
                    message: self.errorMsg,
                    position: 'is-bottom',
                    type: 'is-primary'
                })
          } else {
            store.commit('setUserData', response.user);
            // Update this
            if( response.user.isPasswordChangeNeeded ){
              this.isLoading = false;
              this.$router.replace({ name: 'DashboardPage', params: { existingPassword: this.pass }})
            }else if(this.$route.query.redirect){
              this.isLoading = false;
               this.$router.replace( this.$route.query.redirect)
            }else{
              this.isLoading = false;
              this.$toast.open({
                    duration: 5000,
                    message: 'Logged In Successfully', 
                    position: 'is-bottom',
                    type: 'is-success'
                })
              this.$router.replace({ name: 'DashboardPage'})
            }
          }
          
        })
      }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.has-text-danger {
    padding-bottom: 20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/LoginPage.vue